import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxInputLarge } from 'Packages/FacetDesign/Components/CheckboxInput';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export function SignerMultiPicklist(props) {
  const { options, value, onChange } = props;
  return (
    <div>
      {options.map(({ id, prompt }) => (
        <CheckboxInputLarge
          {...props}
          key={id}
          value={value.includes(id)}
          onChange={(e) => {
            const { checked } = e.target;
            if (checked) {
              onChange(value.concat(id));
            } else {
              onChange(value.filter(personID => personID !== id));
            }
          }}
          label={prompt}
        />
      ))}
    </div>
  );
}

SignerMultiPicklist.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const metaOverrideSet = buildFacetDesignOverride()
  .typeOverride('multipicklist', {
    _component: () => SignerMultiPicklist,
  }, overrideReadOnly);
